import { Col, Grid, Skeleton } from 'gu-ui-kit'
import React from 'react'
import styles from 'modules/Services/NetworksList/services-list.module.scss'

const ServicesListSkeleton = () => {
  return (
    <Skeleton shown>
      <Grid centered gap={16} fluid className={styles['list__container']}>
        {Array(10)
          .fill({})
          .map((item, i) => (
            <Col
              sm="6"
              s="12"
              md="4"
              xl="3"
              className={styles['list__col']}
              key={'skeleton-item-' + i}
            >
              <Skeleton shown width={'100%'}>
                <div className={styles['tile_skeleton']} />
              </Skeleton>
            </Col>
          ))}
      </Grid>
    </Skeleton>
  )
}

export default ServicesListSkeleton
